/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Project_File_DescInputs */

const en_file_export_project_file_desc = /** @type {(inputs: File_Export_Project_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save as .ccprj file`)
};

const fr_file_export_project_file_desc = /** @type {(inputs: File_Export_Project_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer en .ccprj`)
};

const de_file_export_project_file_desc = /** @type {(inputs: File_Export_Project_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als .ccprj-Datei speichern`)
};

const it_file_export_project_file_desc = /** @type {(inputs: File_Export_Project_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva come file .ccprj`)
};

const ru_file_export_project_file_desc = /** @type {(inputs: File_Export_Project_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраните как файл .ccprj`)
};

const es_file_export_project_file_desc = /** @type {(inputs: File_Export_Project_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar como archivo .ccprj`)
};

const zh_cn2_file_export_project_file_desc = /** @type {(inputs: File_Export_Project_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`另存为 .ccprj 文件`)
};

const ja_file_export_project_file_desc = /** @type {(inputs: File_Export_Project_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.ccprjファイルとして保存`)
};

const hi_file_export_project_file_desc = /** @type {(inputs: File_Export_Project_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इसे .ccprj फ़ाइल के रूप में सहेजें`)
};

const pt_pt2_file_export_project_file_desc = /** @type {(inputs: File_Export_Project_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar como arquivo .ccprj`)
};

/**
* | output |
* | --- |
* | "Save as .ccprj file" |
*
* @param {File_Export_Project_File_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_project_file_desc = /** @type {((inputs?: File_Export_Project_File_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Project_File_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_project_file_desc(inputs)
	if (locale === "de") return de_file_export_project_file_desc(inputs)
	if (locale === "it") return it_file_export_project_file_desc(inputs)
	if (locale === "ru") return ru_file_export_project_file_desc(inputs)
	if (locale === "es") return es_file_export_project_file_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_project_file_desc(inputs)
	if (locale === "ja") return ja_file_export_project_file_desc(inputs)
	if (locale === "hi") return hi_file_export_project_file_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_project_file_desc(inputs)
	return en_file_export_project_file_desc(inputs)
});